<template>
    <div>
        <div class="bbt-container">
            <div class="bbt-row">
                <div class="bbt-col-xs-17" style="padding-left:12px;padding-right:12px;">
                    <!-- 咨询轮播 -->
                    <div class="layui-row">
                        <el-carousel :interval="5000" height="405.6px" arrow="hover">
                            <el-carousel-item v-for="item in carouselImgs" :key="item.id">
                                <router-link :to="{path:'/articleDetail/' + item.id}">
                                    <!-- <img :src="item.imagUrl" alt=""> -->
                                    <el-image :src="item.imagUrl" style="width:826px;height:405.6px;">
                                    </el-image>
                                    <div class="feature-banner__title">
                                        <div>
                                            {{item.title}}
                                        </div>
                                    </div>
                                </router-link>
                            </el-carousel-item>
                        </el-carousel>
                    </div>

                    <!-- 新闻分类栏目 -->
                    <div class="bbt-section" id="news_title">
                        <div class="bbt-tab bbt-tab--lg">
                            <ul class="bbt-tab__menu bbt-clearfix">
                                <li @click="transActiveLine" :data-cid="`${item.value}`" data-type="articleList" :class="item.value == '0'? 'active':''" v-for="item in articleCategory" v-bind:key="item.value">{{item.label}}</li>
                            </ul>
                            <div class="li-active__line" style="left: 0px; width: 40px; opacity: 1;"></div>
                        </div>

                        <div v-loading="articleLoad" style="min-height:300px;">
                            <div style="margin-bottom: 24px; margin-top: -8px;"  id="articleList">
                                <div class="article-item-warp" v-for="item in articleNews" v-bind:key="item.id">
                                    <div class="article-item bbt-clearfix">
                                        <div class="article-item__thumb">
                                            <el-image :src="item.imagUrl" lazy>
                                                <div slot="error" class="image-slot">
                                                    <i class="el-icon-picture-outline"></i>
                                                </div>
                                            </el-image>
                                            <!-- <span class="bbt-label bbt-label--top bbt-label--rose">{{item.categoryName}}</span> -->
                                        </div>
                                            <div class="article-item__body">
                                                <h3 class="article-item__title">
                                                    <router-link :to="{path:'/articleDetail/' + item.id}" class="link-dark-major font-bold bbt-block">
                                                        {{item.title}}
                                                    </router-link>
                                                </h3>
                                                <div class="article-item__content" v-html="item.subject"></div>
                                                <div class="article-item__info bbt-clearfix">
                                                    <div class="article-item__author">
                                                        <!-- <a href="/author/56622" target="_blank" class="">
                                                        <img src="https://cdn.8btc.com/wp-content/uploads/2018/09/56622_avatar_1536242445-64x64.png" 
                                                            class="bbt-avatar bbt-avatar--xs" 
                                                            style="margin-right:4px;"  lazy="loaded">
                                                        </a> -->
                                                        <router-link :to="{path:'/authorDetail/' + item.authorId}" class="link-dark-major article-item__author-name">
                                                        {{item.author}}
                                                        </router-link>
                                                        <!-- <span class="bbt-dot"></span> -->
                                                        {{ $filters.formatDate(item.createTime) }}
                                                        <!-- <span class="bbt-dot"></span> -->
                                                        <span v-if="item.tags != ''">
                                                            <a href="javascript:;" 
                                                                class="bbt-tag bbt-tag--flame  bbt-tag--sm" v-for="tag in item.tags.split(',')" v-bind:key="tag">
                                                                {{tag}}
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="article-item__data">
                                                        <span><i class="el-icon-view"></i> {{item.viewCount}}</span>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="bbt-row" style="margin-left:-12px;margin-right:-12px;">
                            <div class="bbt-col-xs-24" style="padding-left:12px;padding-right:12px;">
                                <div class="bbt-btn bbt-btn--default bbt-btn--lg bbt-btn-block" @click="loadMoreArticle" v-if="hasMoreArticle">
                                    查看更多
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="bbt-col-xs-7" style="padding-left:12px;padding-right:12px;">
                    <div class="layui-row">
                        <!-- 快讯时间线 -->
                        <div class="bbt-module flash-module flash-side-module">
                            <div class="flash-module__title">
                                <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" 
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="blockflash" fill="#EE0000" fill-rule="nonzero">
                                            <path d="M3.89483112,18.567108 C3.91394668,18.6205673 3.95098309,18.6668987 3.99996673,
                                            18.6977864 L3.99996673,20.7969568 C4.00116145,20.8516041 3.97009866,20.9026875 3.9199203,
                                            20.9276352 L2.07765763,21.9742504 C2.05734734,21.9944461 2.02867399,22.002762 2.00000064,
                                            21.9991981 C1.97252202,21.9991981 1.94743284,21.9742504 1.91995421,21.9742504 L0.0776915355,20.9276352 C0.0287078976,
                                            20.9026875 -0.00116017427,20.8516041 3.4548603e-05,20.7969568 L3.4548603e-05,18.6977864 C-0.00116017427,
                                            18.641951 0.0287078976,18.5920557 0.0776915355,18.567108 L1.89486503,17.5204927 C1.94384867,
                                            17.4931691 2.00358481,17.4931691 2.05256845,17.5204927 L3.89483112,18.567108 Z M3.18397101,
                                            19.300095 L3.18277629,19.300095 C3.26043327,19.2739593 3.26043327,19.1694166 3.26043327,
                                            19.0910096 C3.20786547,19.0339863 3.12542959,19.0149785 3.05135677,19.0387382 L1.99880592,
                                            19.6410469 L0.946255065,19.0387382 C0.939086725,19.0339863 0.933113115,19.0292343 0.925944775,
                                            19.0268583 C0.855456125,18.9912188 0.76943608,19.0209184 0.734789115,19.0910096 C0.72762078,
                                            19.0993255 0.721647165,19.1100173 0.71925772,19.1195212 C0.6870002,19.1884244 0.71925772,
                                            19.2692074 0.78735692,19.300095 L1.8148186,19.9273514 L1.8148186,21.105833 C1.82079221,
                                            21.19018 1.88889141,21.2555192 1.97252202,21.2614591 C2.05854206,21.2555192 2.12544654,
                                            21.19018 2.13022543,21.105833 L2.13022543,19.9024037 L3.18397101,19.300095 Z" id="Fill-1-path">
                                            </path>
                                            <path d="M19.6135044,20.9989667 C19.5087755,18.8016336 19.0315302,16.6377148 18.1990022,
                                            14.6034441 C17.2233006,12.1414686 15.7438401,9.91072104 13.8573953,8.06223459 C11.9974642,
                                            6.19102629 9.7928559,4.70475229 7.36818445,3.68360718 C5.3518229,2.84557318 3.20421888,
                                            2.36306876 1.02479851,2.25881572 C0.441498653,2.20936236 -0.0052560106,1.71616532 4.67154013e-05,
                                            1.12673471 C-0.0026046476,0.505226239 0.495851593,0.0013365775 1.11229349,0 C3.58071242,
                                            0.149696664 5.9523566,0.681654449 8.1967354,1.5758247 C10.9090797,2.68251074 13.3668932,
                                            4.33986666 15.4177224,6.44497599 C17.4844599,8.52870009 19.1256536,11.0027047 20.2471801,
                                            13.7239762 C21.1738315,15.9761091 21.7027784,18.3739288 21.8088329,20.8091728 C21.8963279,
                                            21.3919205 21.4867232,21.8843016 20.9087261,21.9725157 C20.8464191,21.9818718 20.7854377,
                                            21.9858815 20.7231307,21.9845449 C20.1398309,21.9818718 19.6612289,21.5857242 19.6135044,20.9989667 Z" id="line-3">
                                            </path>
                                            <path d="M11.3240485,10.518514 C12.8519794,11.9698993 14.0499716,13.7133317 14.8420867,
                                            15.6362908 C15.4692323,17.1382471 15.859398,19.2223811 15.9981818,20.8368576 C16.0335324,
                                            21.4449729 15.5490984,21.9645891 14.9193342,21.9987245 C14.3131371,22.0025173 13.8313217,
                                            21.5777216 13.7828783,21.0214415 C13.5576819,17.813981 12.1161635,14.2986901 9.73589055,
                                            12.0508128 C7.3962053,9.77006439 4.28011638,8.38189269 0.963707465,8.14294514 C0.407263017,
                                            8.07593864 -0.00646979695,7.61574329 7.6608327e-05,7.07337019 C0.00138588938,6.47916194 0.504149815,
                                            5.99873819 1.11951191,6.00000249 C1.14831609,6.00126674 1.17712028,6.00253104 1.20461518,
                                            6.00379529 C2.85954644,6.14412959 4.48305495,6.51961864 6.02276945,7.12014829 C7.9971653,
                                            7.92169734 9.7948082,9.07344999 11.3240485,10.518514 Z" id="line-2">
                                            </path>
                                            <path d="M7.83331935,14.208772 C9.58173555,15.9479966 10.6938611,18.2254537 10.9884913,
                                            20.6758648 C11.078402,21.3137189 10.6316152,21.9017622 9.99394125,21.988931 C9.9372284,
                                            21.9972327 9.8791323,22 9.81965295,22 C9.21656,21.9861637 8.7158269,21.5295653 8.64943135,
                                            20.9290693 C8.4032145,19.0044382 7.52762315,17.2140192 6.15959815,15.8386897 C4.77774074,
                                            14.4771965 2.9905938,13.6041251 1.06788928,13.3481533 C0.462029871,13.296959 -0.00412223213,
                                            12.7877827 2.74898496e-05,12.1762176 C0.0083269338,11.5189927 0.54779079,10.9904456 1.20621335,
                                            11.000131 C1.24494409,11.000131 1.28505807,11.0028983 1.32378881,11.0070491 C3.78457394,
                                            11.3418879 6.072454,12.4681638 7.84023555,14.2156902" id="line-1" opacity="0.900000036">
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                                <span class="typo-h6" data-v-6c1bc408=""></span>
                                <div class="bbt-module__more" data-v-6c1bc408="">
                                    <router-link to="/more_article" class="link-dark-minor">
                                        更多<i class="bbt-icon bbt-icon-right"></i>
                                    </router-link>
                                </div>
                            </div>
                            <div class="timeDiv">
                                <li class="layui-timeline-item" v-for="item in newsLetter" v-bind:key="item.id">
                                    <i class="layui-icon layui-timeline-axis">&#xe63f;</i>
                                    <div class="layui-timeline-content layui-text">
                                        <h3 class="layui-timeline-title createTimeTitle">{{item.createTime | timeInteval}}</h3>
                                        <span class="timeLineTitle">【{{item.title}}】</span>
                                        <div class="timeLineContent" v-html="item.content">
                                        </div>
                                        <p style="color:rgba(0,0,0,.56);">来源：{{item.author}}</p>
                                    </div>
                                </li>
                            </div>
                            <div class="flash-module__mask"></div>
                        </div>
                    </div>

                    <div class="layui-row" style="margin-top:30px;">
                        <div class="bbt-module">
                            <div class="bbt-module__header">
                                热门标签
                            </div>

                            <div class="bbt-module__body" style="padding-bottom:8px">
                                <router-link :to="{path:'/search/' + item}" class="bbt-tag bbt-tag--flame" v-for="item in hotTags" v-bind:key="item">
                                    {{item}}
                                </router-link>
                            </div>

                        </div>
                    </div>
                        
                </div>
            </div>
            <div class="bbt-row">
                <!-- 社区 -->
                <!-- <section v-if="setSwitch.status == 'off'" class="bbt-section forum-section" style="margin-bottom: 0px;" id="community_title">
                    <div class="bbt-container">
                        <div class="bbt-row" style="margin-left: -12px; margin-right: -12px;">
                            
                            <div class="bbt-col-xs-18" style="padding-left: 12px; padding-right: 12px;">
                                <section class="bbt-section">
                                    <div class="bbt-section__header">
                                        <div class="bbt-section__title">
                                        社区
                                        </div>
                                    </div>
                                    <div class="bbt-row" style="margin-left: -12px; margin-right: -12px;">
                                        <div class="bbt-col-xs-8" style="padding-left: 12px; padding-right: 12px;" v-for="(item, index) in postList" :key="item.id">
                                            <div class="forum-plate">
                                                <div class="forum-plate__header">
                                                    <div class="forum-plate__thumb">
                                                        <router-link :to="{path:'/postIndex/' + item.id + '?pt=' + item.category}">
                                                            <el-image
                                                            class="img-full"
                                                            :src="`${publicPath}default/forum`+ index +`@2x.webp`"
                                                            :fit="cover"></el-image>
                                                        </router-link>
                                                    </div>
                                                    <div class="forum-plate__title">
                                                        <router-link :to="{path:'/postIndex/' + item.id + '?pt=' + item.category}" class="link-dark-major">
                                                            {{item.category}}
                                                        </router-link>
                                                    </div>
                                                </div>
                                                
                                                <ul class="bbt-list">
                                                    <li v-for="cateItem in item.list" :key="cateItem.id" class="postLink">
                                                        <router-link :to="{path:'/articleDetail/' + cateItem.id + '?t=p'}" class="link-dark-major">
                                                        {{cateItem.title}}
                                                        </router-link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            
                            <div class="bbt-col-xs-6" style="padding-left: 12px; padding-right: 12px;">
                                <section data-v-6672b0fc="" class="bbt-section">
                                    <div class="bbt-section__header">
                                        <div class="bbt-section__title">
                                        热帖
                                        </div>
                                    </div>
                                    <div class="forum-posts">
                                        <div 
                                        :class="{'forum-post forum-post--active__0': index == 0, 
                                        'forum-post forum-post--active__1': index == 1, 'forum-post forum-post--active__2': index == 2,
                                        'forum-post forum-post--normal': index > 2}" 
                                        v-for="(item, index) in postListHat" :key="item.id">
                                            <div class="forum-post__title">
                                                <span>{{index + 1}}</span>
                                                <router-link :to="{path:'/articleDetail/' + item.id + '?t=p'}" class="link-dark-major">
                                                {{item.title}}
                                                </router-link>
                                            </div>
                                            <div class="forum-post__info">
                                                <span>
                                                    来自
                                                    <router-link :to="{path:'/postIndex/' + item.category + '?pt=' + item.categoryName}" class="link-dark-major">
                                                        {{ item.categoryName }}
                                                    </router-link>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section> -->
                <!-- 图书 -->
                <section class="layui-row" id="book_title">
                    <!-- 图书展示 -->
                    <div class="bbt-container">
                        <div class="bbt-section__header">
                            <div class="bbt-section__title">图书</div>
                            <div class="bbt-tab" style="margin-left: 108px;">
                                <ul class="bbt-tab__menu bbt-clearfix" id="bookTab">
                                    <li class="active" @click="transActiveLine" data-type="bookList">全部</li>
                                    <li class="" @click="transActiveLine" data-type="bookList">出版图书</li>
                                    <!-- <li class="" @click="transActiveLine">电子图书</li> -->
                                </ul>
                                <div class="li-active__line" style="left: 0px; width: 32px; opacity: 1;"></div>
                            </div>
                            <div class="bbt-section__more">
                                <router-link to="/more_book">
                                    更多<i class="bbt-icon bbt-icon-right"></i>
                                </router-link>
                            </div>
                        </div>

                        <div id="bookBody" style="min-height:400px;" v-loading="loading">
                            <div class="book-module" id="bookList">
                                <div class="bbt-row" style="margin-left: -12px; margin-right: -12px;">
                                    <el-row type="flex" justify="space-between" :gutter="25" v-for="book in bookList" :key="book">
                                        <el-col :xl="8" :lg="7" :md="6" :sm="24" v-for="item in book" :key="item.id">
                                            <div class="book-item bbt-clearfix">
                                                <div class="book-item__thumb">
                                                    <router-link :to="{path:'/book_detail/' + item.id}">
                                                        <el-image
                                                        class="img-full"
                                                        :src="item.bookCover"
                                                        :fit="cover"></el-image>
                                                    </router-link>
                                                </div>

                                                <div class="book-item__body">
                                                    <div class="book-item__title">
                                                        <router-link :to="{path:'/book_detail/' + item.id}" class="link-dark-major font-bold">
                                                            {{item.bookName}}
                                                        </router-link>
                                                    </div>
                        
                                                    <div class="book-item__desc">
                                                        {{item.descriptions}}
                                                    </div>

                                                    <div class="book-item__author">
                                                        <span class="author_name">
                                                            <span>作者：{{item.authors.length > 13 ? item.authors.substr(0, 13) + '...' : item.authors}}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        </div>
        <div id="quickLinks">
            <ul>
                <li @click="transScrollWin" v-for="item in quicks" :key="item.type" :data-type="item.type">{{item.title}}</li>
            </ul>
        </div>
    </div>

    
</template>

<script>
import { setTimeout } from 'timers';
import { 
    getNewsTop, 
    getCarouselImgs, 
    getArticleCategory, 
    getNewsLetter,
    getHatTags,
    getPostList,
    getPostListHat,
    getSetSwitch,
    getBookList
} from '@/api/api';
export default {
    name:'TabIndex',
    data(){
        return {
            publicPath: process.env.BASE_URL,
            pagNo:0,
            carouselImgs:[],
            articleNews:[],
            articleCategory:[],
            newsLetter:[],
            hotTags:[],
            postList:[],
            bookList:[],
            postListHat:[],
            quicks:[
                {
                    type:'news_title',
                    title:'新闻'
                },
                {
                    type:'community_title',
                    title:'社区'
                },
                {
                    type:'book_title',
                    title:'图书'
                },
            ],
            loading:false,
            articleLoad:false,
            hasMoreArticle:true,
            articleType:0,
            setSwitch: {}
        }
    },
    methods:{
        ScrollTop:function(number = 0, time){
            if (!time) {
                document.body.scrollTop = document.documentElement.scrollTop = number;
                return number;
            }
            const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
            let spacingInex = time / spacingTime; // 计算循环的次数
            let nowTop = document.body.scrollTop + document.documentElement.scrollTop; // 获取当前滚动条位置
            let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
            let scrollTimer = setInterval(() => {
                if (spacingInex > 0) {
                    spacingInex--;
                    this.ScrollTop(nowTop += everTop);
                } else {
                    clearInterval(scrollTimer); // 清除计时器
                }
            }, spacingTime);
        },
        transScrollWin:function (event) {
            let type = event.target.dataset.type;
            let e = document.querySelector('#' + type);
            $(event.target).attr('class', 'active').siblings().removeAttr('class');
            this.ScrollTop(e.offsetTop, 200);
        },
        searchResult:function(event) {
            const search_text = event.target.innerText;
            this.$router.push({name:'search', params: {search_text}});
        },
        transActiveLine:function(event) {
            // 图书栏目/文章类别切换
            var _vm = this;
            var l_offset = event.target.offsetLeft;
            var w_offset = event.target.offsetWidth;
            // 类型
            let eventType = event.target.dataset.type;
            $(event.target).parent().siblings('.li-active__line').css({left:l_offset});
            $(event.target).parent().siblings('.li-active__line').width(w_offset);
            $(event.target).attr('class', 'active').siblings().removeAttr('class');
            switch(eventType) {
                case 'bookList':
                    $("#bookList").fadeOut(.3);
                    _vm.loading = true;
                    setTimeout(function(){
                        _vm.loading = false;
                        $("#bookList").fadeIn(.3);
                    },2000)
                break;
                case 'articleList':
                    _vm.articleType = event.target.dataset.cid;
                    _vm.hasMoreArticle = false;
                    _vm.articleLoad = true;
                    _vm.pagNo = 0;
                    _vm.articleNews = [];
                    _vm.loadMoreArticle(_vm, _vm.pagNo, _vm.articleType);
                break;
            }
        },
        loadMoreArticle:function() {
            // 文章列表更多加载
            this.pagNo++
            this.loadArticleList(this, this.pagNo, this.articleType);
        },
        loadArticleList:function(_vm, pagNo, category) {
            var _vm = this;
            let param = {
                pagNo: pagNo,
                category: category
            }
            getNewsTop(param).then((res) => {
                // console.log(res);
                let d = res.data;
                if(d.code != "2000000") {
                    console.error('get menue error.');
                    return;
                }
                if(d.data) {
                    d.data.forEach((item, index) => {
                        _vm.articleNews.push(item);
                    });
                    _vm.articleLoad = false;
                    _vm.hasMoreArticle = true;
                } else {
                    _vm.hasMoreArticle = false;
                    // _vm.$message('没有更多新闻了');
                    _vm.$alert('没有更多新闻了', '提示', {
                        type:'warning',
                        closeOnClickModal:true,
                        closeOnPressEscape:true,
                        confirmButtonText: '确定',
                        callback: action => {
                            
                        }
                    });
                }
            });
        },
        loadDataByAsync:function(URL, DATA, CALLBACK_FUNC) {
            $.get(URL, DATA, CALLBACK_FUNC);
        }
    },
    computed: {
    
    },
    created() {
    },
    updated(){
        layui.use(['layer', 'jquery'], function(){   
            let layer = layui.layer;
            let $ = layui.jquery;
            // 首页左侧快速导航栏
            layer.open({
                type:1,
                content:$("#quickLinks"),
                skin:'my-layui-layer1',
                shade:0,
                title:false,
                closeBtn:0,
                area:'80px',
                // offset:['300px', '250px'],
                offset: 'r',
                btn:[]
            });
        });
    },
    mounted() {
        this.loadMoreArticle(this, this.pagNo, this.articleType);
        getCarouselImgs({}).then((res) => {
            this.carouselImgs = res.data.data;
        });
        getArticleCategory({}).then((res) => {
            this.articleCategory = res.data.data;
        });
        getNewsLetter({}).then((res) => {
            this.newsLetter = res.data.data;
        });
        getHatTags({}).then((res) => {
            this.hotTags = res.data.data;
        });
        getPostList({}).then((res) => {
            this.postList = res.data.data;
        });
        getPostListHat({}).then((res) => {
            this.postListHat = res.data.data;
        });
        getSetSwitch({}).then((res) => {
            this.setSwitch = res.data.data;
        });
        getBookList({}).then((res) => {
            if(res.data.data.length > 0) {
                var a = [];
                for(let i = 0;i <= res.data.data.length;i++) {
                    if(i % 3 == 0 && i != 0) {
                        if(a.length > 0) {
                            this.bookList.push(a);
                        }
                        a = [];
                    } 
                    a.push(res.data.data[i]);
                }
            }
        });
    }
}
</script>

<style scoped>
.postLink {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.timeLineContent {
    /* white-space: pre-wrap; */
    word-wrap:break-word;
}
/* 社区 */
.forum-posts .forum-post.forum-post--active__2 .forum-post__title span {
    background: #fdb500;
}
.forum-posts .forum-post.forum-post--active__1 .forum-post__title span {
    background: #f46300;
}
.forum-posts .forum-post__info span {
    display: inline-block;
    max-width: 140px;
    margin-left: 24px;
    overflow: hidden;
    height: 20px;
}
.forum-posts .forum-post__title a {
    display: inline-block;
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.forum-posts .forum-post.forum-post--active__0 .forum-post__title span {
    background: #e80404;
}
.forum-posts .forum-post__title span {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: #bdbdbd;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    color: #fff;
    margin-right: 4px;
    vertical-align: top;
}
.forum-posts .forum-post__info {
    color: rgba(0,0,0,.56);
    font-size: 12px;
    line-height: 20px;
    overflow: hidden;
    height: 20px;
}
.forum-posts .forum-post__title {
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    margin-bottom: 4px;
    height: 22px;
}
.forum-posts .forum-post {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px dashed rgba(0,0,0,.08);
}
.bbt-list>li a {
    /* display: inline-block; */
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.bbt-list>li {
    position: relative;
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    list-style: none;
    height: 22px;
}
.forum-plate img {
    border-radius: 4px;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,.06), 0 1px 10px 0 rgba(0,0,0,.04), 0 0 4px -1px rgba(0,0,0,.08);
    transition: all .3s ease;
}
.img-full {
    display: block;
    width: 100%;
    height: auto;
    transition: all .3s;
}
.img-full:hover {
    transform: scale(1.1);
}
.forum-plate__info {
    color: rgba(0,0,0,.56);
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 16px;
    white-space: nowrap;
}
.forum-plate__title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
}
.forum-plate__thumb {
    float: left;
    width: 64px;
    margin-right: 16px;
    overflow: hidden;
    border-radius: 4px;
}
.bbt-list {
    margin: 0 auto;
    margin-top:50px;
    padding-left: 0;
    min-height:88px;
}
.forum-plate__header {
    position: relative;
}
.forum-plate {
    margin-bottom: 24px;
    border-radius: 4px;
    padding: 16px;
    background: #f8f8f8;
}
.bbt-section__more>a {
    color: rgba(0,0,0,.32);
    font-size: 14px;
    line-height: 22px;
    font-weight: 700;
    transition: all .3s ease;
}
.bbt-section__more {
    position: absolute;
    right: 0;
    top: 8px;
}
.bbt-section__title {
    color: rgba(0,0,0,.88);
    font-weight: 700;
    font-size: 30px;
    line-height: 38px;
    margin-right: 48px;
    float: left;
}
.bbt-section__header {
    position: relative;
    margin-bottom: 24px;
}
.bbt-section__header:after {
    clear: both;
}
.bbt-section__header:after, .bbt-section__header:before {
    display: table;
    content: "";
}
.bbt-section {
    margin-bottom: 24px;
}
.bbt-col-xs-18 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 75%;
}
.bbt-col-xs-6 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 25%;
}
/* END */

.bbt-btn.bbt-btn--default {
    color: rgba(0,0,0,.88);
    background: #f1f1f1;
    border-color: #f1f1f1;
    transition: all .3s ease;
}
.bbt-btn.bbt-btn-block {
    display: block;
    width: 100%;
}
.bbt-btn.bbt-btn--lg {
    font-size: 14px;
    padding: 12px 18px;
    border-radius: 4px;
}
.bbt-col-xs-24 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 100%;
}
.feature-banner__title {
    position: absolute;
    background: rgba(0,0,0,.56);
    bottom: 10px;
    left: 0;
    right: 0;
    padding: 16px 8px;
    margin: 16px;
    border-radius: 4px;
    font-size: 20px;
    line-height: 28px;
    color: #fff;
    font-weight: 700;
    transition: all .3s ease;
}
.author_name span {
    font-weight:700;
}
.author_name {
    display:block;
    color:#5c5c5c;
    font-size: .5rem;
    margin-bottom:10px;
}
.book-item:hover .book-item__thumb img{
    margin-top:-10px;
}

.flash-module.flash-side-module {
    padding-right: 18px;
}

.flash-module {
    position: relative;
}
.bbt-module {
    margin-bottom: 48px;
    background: #f8f8f8;
    padding: 24px;
    border-radius: 4px;
    transition: all .3s ease;
}
.flash-module__mask {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    height: 96px;
    background-image: linear-gradient(0deg,#f8f8f8 4%,hsla(0,0%,97%,0));
    border-radius: 0 0 4px 4px;
}
.bbt-col-xs-7 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 29.16666667%;
}
.bbt-tab.bbt-tab--lg .li-active__line {
    bottom: -6px;
}

.bbt-tab .li-active__line {
    height: 4px;
    position: absolute;
    left: 0;
    width: 40px;
    bottom: 2px;
    border-radius: 2px;
    background: #409EFF;
    transition: all .3s ease;
}
.bbt-col-xs-17 {
    float: left;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 70.83333333%;
}
.bbt-tab {
    position: relative;
    margin-bottom: 24px;
}
.bbt-section {
    margin: 30px 0;
}
.bbt-tab.bbt-tab--lg .bbt-tab__menu>li {
    font-size: 20px;
    line-height: 28px;
    padding: 0;
    position: relative;
}
.bbt-tab__menu>li.active {
    color: rgba(0,0,0,.88);
}
    /* 浮动定位栏 */
    #quickLinks {
        display:none;
        padding:0 16px;
    }
    #quickLinks ul li.active, #quickLinks ul li:hover {
        color: #ec2c2c;
    }
    #quickLinks ul {
        padding: 0;
        margin: 0;
        list-style-type: none;
    }
    #quickLinks ul li {
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        line-height: 22px;
        color: rgba(0,0,0,.56);
        padding: 20px 0;
        border-bottom: 1px dashed rgba(0,0,0,.08);
        white-space: nowrap;
    }
    #quickLinks ul li:last-child {
        border-bottom:none;
    }
    /* END */
    *, :after, :before {
        box-sizing: border-box;
    }
    /* 图书CSS */
    .bbt-tab .li-active__line {
        height: 4px;
        position: absolute;
        left: 0;
        width: 40px;
        bottom: 2px;
        border-radius: 2px;
        background: #409EFF;
        transition: all .3s ease;
    }

    .bbt-tab__menu>li:nth-child(1) {
        margin-left:0;
    }

    .bbt-tab__menu>li {
        margin-left: 34px;
    }

    .book-item__author .bbt-avatar {
        bottom: 24px;
        margin-right: 8px;
        display: inline-block;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top;
    }

    .bbt-avatar.bbt-avatar--sm {
        max-width: 32px!important;
        width: 32px!important;
        height: 32px!important;
    }
    .bbt-avatar {
        border-radius: 50%;
        vertical-align: middle;
    }

    .book-item__title {
        max-height: 48px;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 16px;
        line-height: 24px;
        color: rgba(0,0,0,.88);
        margin-bottom: 8px;
    }

    .book-item__desc {
        font-size: .8rem;
        line-height: 20px;
        color: rgba(0,0,0,.56);
        height: 80px;
        overflow: hidden;
        margin-bottom:10px;
    }

    .book-item__author {
        position: absolute;
        left: 188px;
    }

    .bbt-col-xs-8 {
        float: left;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: 33.33333333%;
    }

    .book-item__thumb img {
        border-radius: 4px;
        min-height: 215px;
        box-shadow: 0 4px 5px 0 rgba(0,0,0,.06), 0 1px 10px 0 rgba(0,0,0,.04), 0 0 4px -1px rgba(0,0,0,.08);
        transition: all .3s ease;
    }

    .book-item__thumb {
        margin-top: -40px;
        float: left;
        width: 148px;
        height: 215px;
        margin-right: 16px;
    }

    .book-item {
        margin-bottom: 24px;
        margin-top: 16px;
        padding: 16px 24px 24px;
        background: #fff;
        border-radius: 4px;
        position: relative;
        border: 1px solid rgba(0,0,0,.08);
    }

    .bbt-section__more {
        position: absolute;
        right: 0;
        top: 8px;
    }

    .bbt-section__more>a {
        color: rgba(0,0,0,.32);
        font-size: 14px;
        line-height: 22px;
        font-weight: 700;
        transition: all .3s ease;
    }

    .bbt-tab__menu>li:hover {
        color: rgba(0,0,0,.88);
        cursor: pointer;
        transition: all .3s ease;
    }

    .bbt-tab__menu>li.active {
        color: rgba(0,0,0,.88);
    }

    .bbt-tab__menu>li {
        font-size: 16px;
        line-height: 24px;
        color: rgba(0,0,0,.56);
        padding: 7px 0;
        float: left;
        list-style: none;
        position: relative;
        font-weight: 700;
        transition: all .3s ease;
    }

    .bbt-tab__menu {
        position: relative;
    }
    .bbt-clearfix:after {
        clear: both;
    }

    .bbt-clearfix:after, .bbt-clearfix:before {
        display: table;
        content: "";
    }

    .bbt-section__header .bbt-tab {
        margin-bottom: 0!important;
    }
    .bbt-tab {
        position: relative;
        margin-bottom: 24px;
    }

    .bbt-section__title {
        color: rgba(0,0,0,.88);
        font-weight: 700;
        font-size: 30px;
        line-height: 38px;
        margin-right: 48px;
        float: left;
    }

    .bbt-section__header {
        position: relative;
        margin-bottom: 24px;
    }

    .bbt-section__header:after {
        clear: both;
    }

    .bbt-section__header:after, .bbt-section__header:before {
        display: table;
        content: "";
    }

    @media (min-width: 1200px) {
        .bbt-container {
            width: 1200px;
        }
    }
        
    .bbt-container {
        padding-left: 12px;
        padding-right: 12px;
        margin: 0 auto;
    }
    .bbt-container:after, .bbt-container:before {
        display: table;
        content: "";
    }
    .bbt-container:after {
        clear: both;
    }

    /* END */
    
    .bbt-tag {
        margin-bottom: 16px;
    }
    .bbt-module__header {
        font-size: 20px;
        line-height: 28px;
        color: rgba(0,0,0,.88);
        font-weight: 700;
        margin-bottom: 16px;
        position: relative;
        padding-left: 12px;
    }
    .bbt-module__header:before {
        content: "";
        width: 4px;
        height: 20px;
        position: absolute;
        top: 4px;
        left: 0;
        border-radius: 2px;
        background: #e00;
    }
    .bbt-module {
        padding-bottom: 8px;
    }
    .bbt-module {
        margin-bottom: 48px;
        background: #f8f8f8;
        padding: 24px;
        border-radius: 4px;
        transition: all .3s ease;
    }
    .timeLineTitle {
        font-weight:bold;
    }
    .newsTab li {
        font-size:1.3rem;
        font-weight:bold;
    }
    .layui-timeline-axis {
        left:-2px;
        color:rgba(0,0,0,.56);
    }
    .timeDiv {
        height:800px;
        padding:0 10px 0 0;
        overflow-y: scroll;
    }
    .timeDiv::-webkit-scrollbar {/*滚动条整体样式*/
        width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
    }
    .timeDiv::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    .timeDiv::-webkit-scrollbar-track {/*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }

    .createTimeTitle{
        font-size:13px;
        color:rgba(0,0,0,.56);
    }

    @media screen and (min-width: 992px) {
        .layui-col-md-offset2 {
            margin-left: 21.666667%;
        }
    }
    a {
        text-decoration: none;
    }


    h3 {
        display: block;
        font-size: 1.17em;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: bold;
    }

    .article-item-warp{
        position: relative;
        margin: 0 -16px;
        padding: 24px 16px;
        border-radius: 4px;
        transition: all .3s ease;
        border:1px solid transparent;
    }

    .article-item-warp:hover {
        box-shadow:0 10px 20px #ccc;
        border:1px solid #ccc;
    }

    .article-item-warp:first-child:before {
        position: absolute;
        content: "";
        height: 1px;
        left: 16px;
        right: 16px;
        top: 0;
        border-top: 1px dashed rgba(0,0,0,.08);
    }

    .article-item-warp:after {
        position: absolute;
        content: "";
        height: 1px;
        left: 16px;
        right: 16px;
        bottom: 0;
        border-bottom: 1px dashed rgba(0,0,0,.08);
    }

    .article-item {
        position: relative;
    }

    .bbt-clearfix:after {
        clear: both;
    }
    .bbt-clearfix:after, .bbt-clearfix:before {
        display: table;
        content: "";
    }

    .article-item__thumb {
        position: relative;
        float: left;
        margin-right: 16px;
        width: 256px;
        height: 154px;
        overflow: hidden;
        border-radius: 4px;
    }

    .bbt-label.bbt-label--rose {
        background: #e80404;
    }
    .bbt-label.bbt-label--top {
        position: absolute;
        top: 8px;
        left: 0;
        z-index: 2;
    }
    .bbt-label {
        padding: 4px 16px 4px 8px;
        font-size: 12px;
        line-height: 20px;
        color: #fff;
        border-top-right-radius: 28px;
        border-bottom-right-radius: 28px;
    }

    .article-item__title {
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 8px;
        margin-top: 0;
        max-height: 56px;
        overflow: hidden;
    }

    .article-item__content {
        font-size: 14px;
        line-height: 22px;
        color: rgba(0,0,0,.56);
        max-height: 44px;
        margin-bottom: 24px;
        word-break: break-all;
        display: -webkit-box;
        box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .article-item__info {
        position: absolute;
        left: 272px;
        height:40px;
        bottom: -20px;
        right: 0;
        font-size: 1rem;
        line-height: 22px;
        color: rgba(0,0,0,.56);
    }

    .article-item__author {
        float: left;
    }

    .article-item__data {
        float: right;
    }

    .bbt-dot {
        width: 4px;
        height: 4px;
        display: inline-block;
        background: rgba(0,0,0,.08);
        border-radius: 50%;
        margin: 0 8px 0 4px;
        vertical-align: middle;
    }

    .article-item__author-name {
        max-width: 120px;
        vertical-align: top;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .link-dark-major {
        color: rgba(0,0,0,.88);
        transition: all .3s ease;
    }

    .link-dark-major:hover {
        color:#e00;
    }

    .article-item__title a:visited {
        color: #5c5c5c;
    }
    .font-bold, .font-medium {
        font-weight: 700;
    }
    .bbt-block {
        display: block;
    }

    .bbt-tag.bbt-tag--flame {
        color: #f46300;
        background: rgba(244,99,0,.12);
    }
    .bbt-tag.bbt-tag--sm {
        padding: 4px 8px;
        line-height: 1;
    }
    .bbt-tag {
        font-size: 12px;
        line-height: 20px;
        border-radius: 100px;
        padding: 3px 12px;
        margin-right: 8px;
        display: inline-block;
        transition: all .3s ease;
        font-weight: 500;
    }

    .bbt-tag:hover {
        font-size: 16px;
        font-weight:bold;
    }

    .bbt-icon {
        line-height: 1;
        font-size: 14px;
    }

    .bbt-icon {
        font-family: bbt-icon!important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .bbt-icon-eye:before {
        content: "\E622";
    }

    .bbt-avatar.bbt-avatar--xs {
        max-width: 24px!important;
        width: 24px!important;
        height: 24px!important;
    }
    .bbt-avatar {
        border-radius: 50%;
        vertical-align: middle;
    }


    .flash-module__title {
        margin: 10px 0;
        height: 28px;
        position: relative;
    }

    .bbt-module__more {
        float: right;
        position: absolute;
        right: 0;
        top: 3px;
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
    }

    .bbt-module__more>a i {
        margin-left: 4px;
        font-size: 12px;
    }

    .bbt-icon-right:before {
        content: ">";
    }

    svg {
        width: 22px;
        height: 22px;
    }
    svg:not(:root) {
        overflow: hidden;
    }

    .flash-module__title .typo-h6 {
        display: inline-block;
        margin-left: 8px;
        width: 44px;
        height: 20px;
        background: url(https://webcdn.8btc.com/public/common/flash.svg) no-repeat;
    }

    .layui-timeline {
        background-color:#f8f8f8;
        border-radius:10px;
        margin-left:20px;
        padding:5px 20px;
    }

    .content-index {
        margin-top:20px;
    }
</style>